/* eslint-disable max-len */
import React from 'react';
import { Link } from 'react-router-dom';

import { Home } from 'lucide-react';

const Pages404 = () => {
    document.title = `404 | Antar Back Office`;

    React.useEffect(() => {
        const bodyElement = document.body;

        bodyElement.classList.add(
            `flex`,
            `items-center`,
            `justify-center`,
            `min-h-screen`,
            `py-16`,
            `bg-cover`,
            `bg-auth-pattern`,
            `dark:bg-auth-pattern-dark`,
            `font-public`
        );

        return () => {
            bodyElement.classList.remove(
                `flex`,
                `items-center`,
                `justify-center`,
                `min-h-screen`,
                `py-16`,
                `bg-cover`,
                `bg-auth-pattern`,
                `dark:bg-auth-pattern-dark`,
                `font-public`
            );
        };
    }, []);

    return (
        <React.Fragment>
            <div className="">
                <div>
                    <Link to="/">
                        {/* <img src={logoLight} alt="" className="hidden h-6 mx-auto dark:block" /> */}
                        {/* <img src={logoDark} alt="" className="block h-6 mx-auto dark:hidden" /> */}
                        {/* <img
                            src="https://cdn.goldady.com/favicon/safari-pinned-tab.svg"
                            alt=""
                            className=" h-16 mx-auto dark:block"
                        /> */}
                    </Link>

                    {/* <div className="mt-10"><img src={error404} alt="" className="h-64 mx-auto" /></div> */}
                    <div className=" mt-2 text-center">
                        <h4 className="mb-4 text-purple-500">OPPS , PAGE NOT FOUND</h4>
                        {/* <p className="mb-6 text-slate-500 dark:text-zink-200">It will be as straightforward as Occidental; in fact, it will be just like Occidental to an English speaker.</p> */}
                        <Link
                            to="/"
                            className="btn border-custom-500 bg-custom-500 text-white transition-all duration-200 ease-linear hover:border-custom-600 hover:bg-custom-600 hover:text-white focus:border-custom-600 focus:bg-custom-600 focus:text-white focus:ring focus:ring-custom-100 active:border-custom-600 active:bg-custom-600 active:text-white active:ring active:ring-custom-100 dark:ring-custom-400/20"
                        >
                            <Home className="inline-block size-3 ltr:mr-1 rtl:ml-1"></Home>
                            {` `}
                            <span className="align-middle">Back to Home</span>
                        </Link>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};

export default Pages404;
